import React, {useCallback} from "react";
import {useStoreActions, useStoreState} from "easy-peasy";
import * as R from "ramda";

const onEnter = inputRef => event => {
    if (event.keyCode === 13) {
        inputRef.current.click();
    }
};

export default props => {
    const updateAnswers = useStoreActions(actions => actions.answers.update);
    const answers       = useStoreState(actions => actions.answers.current);
    const inputRef      = React.createRef();

    const onChange = useCallback(e => {
        const selections = answers[3] || [];
        answers.length   = 4;

        const getDataLayerArgument = (firstAnswer, currentAnswer, checked) => ({name: `${firstAnswer}_${currentAnswer}`, checked});

        window.dataLayer.push(getDataLayerArgument(answers[0], props.result, e.target.checked));

        if (e.target.checked) {
            updateAnswers(
                R.adjust(3, () => [...selections, props.result], answers)
            );
        } else {
            updateAnswers(
                R.adjust(3, () => R.without([props.result], selections), answers)
            );
            if (e.nativeEvent.screenX !== 0 && e.nativeEvent.screenY !== 0) {
                // came from click
                e.target.blur();
            }
        }
    }, [answers, props.result, updateAnswers]);

    return (
        <div className="checkbox-container">
            <input
                ref={inputRef}
                id={`${props.index}_checkbox`}
                name="options"
                className="checkbox"
                type="checkbox"
                onChange={onChange}
                onKeyDown={onEnter(inputRef)}
            />
            <label className={`checkbox-label`} htmlFor={`${props.index}_checkbox`}>{props.answer}</label>
        </div>
    );
};

